import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import ExampleVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import DateTermApi from './api/DateTermApi';
import BuyerContractApi from './api/BuyerContractApi';
import SsoVuexModule from '@abaco/sso-web-module/src/abaco-module/state';
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import DashboardChartsModule from '@abaco/dashboard-module/src/modules/charts';
import PaymentApi from '../buyer-contract-module/api/PaymentApi';

export const MODULE_ID = "buyer_contract_module";

const rootPath = "/sitiagri-rest-api/api_basic";

export default class BuyerContractModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private bcApi!: BuyerContractApi;
    private dtApi!: DateTermApi;
    private pymntApi!: PaymentApi;
    private apiCreated = false;

    private router!: VueRouter;
    private http!: HTTPClient;
    private ssoStore!: SsoVuexModule;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new ExampleVuexModule();
    menu: MenuItem[] = [];

    dependsOn = {
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
    };


    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }

        this.ssoStore = ssoModule.vuexModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const BuyerContractApi = (await import("./api/BuyerContractApi")).default;
        this.bcApi = new BuyerContractApi(http, rootPath, this.ssoStore);
        const DateTermApi = (await import("./api/DateTermApi")).default;
        this.dtApi = new DateTermApi(http, rootPath, this.ssoStore);
        const PaymentApi = (await import("../buyer-contract-module/api/PaymentApi")).default;
        this.pymntApi = new PaymentApi(http, rootPath);
    }

    public get buyerContractApi(){
        return this.bcApi;
    }

    public get dateTermApi(){
        return this.dtApi;
    }

    public get payementApi(){
        return this.pymntApi;
    }

}
